<template>
<MyTransition :myName="'opacity'">
    <div class="loading" v-if="laodingShow">
        <div :class="['loading_bg',size]">
            <Div class="text">
                <Div class="icon">
                    <p></p>
                </Div>
                Loading
            </Div>
    </div>
  </div>

</MyTransition>

</template>
<style lang="scss">
.loading {
  position: relative;
}
.loading_bg {
  opacity: 1;
  background: #fff;
  top: 0;
  left: 0;
  z-index: 999999;
  color: #000;
  &.all {
    width: 100%;
    height: 100vh;
    position: fixed;
  }
  &.part {
    width: 100%;
    height: fit-content;
    position: absolute;
  }
  .text {
    text-align: center;
    margin: 150px 0;
    position: relative;
    font-size: 15px;
  }
  .icon {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0px auto;
    animation: ball 2s infinite;
    p {
      background: var(--mainColor);
      width: 30px;
      height: 30px;
      position: relative;
      border-radius: 50px;
    }
    @keyframes ball {
      0% {
        transform: rotateY(0);
      }
      100% {
        transform: rotateY(360deg);
      }
    }
  }
}
</style>

<script>
export default {
  name: "loading",
  data() {
    return {};
  },
  props: {
    part: Boolean
  },
  computed: {
    size() {
      if (this.part === true) {
        return "part";
      } else {
        return "all";
      }
    },
    laodingShow() {
      return this.$store.state.loading
      // return true;
    }
  }
};
</script>
